import { PropsWithChildren } from "react";

import './ImageSection.scss';

type Props = {
  comingSoon: boolean,
  imageUrl: string
}

export const ImageSection = ({ imageUrl, children }: PropsWithChildren<Props>) => {
  return (
    <div
      className="module-image"
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className='module-tag'>
        {children}
      </div>
    </div>
  );
}